import { dataTreasureChest } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTreasureChest = /*#__PURE__*/createIcon(dataTreasureChest)
export default IconTreasureChest
